module.exports = __webpack_public_path__ + "assets/img/5815d25b65919b4d4d35825106d3b7a2.png";